import { VStack } from '@/components/ui/vstack';
import { View } from '@/components/ui/view';
import { Text } from '@/components/ui/text';
import { HStack } from '@/components/ui/hstack';
import { Box } from '@/components/ui/box';
import i18n from 'i18n-js';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { FlatList } from 'react-native-gesture-handler';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useDispatch, useSelector } from 'react-redux';
import FloatingLabelInput from '../components/basic/FloatingLabelInput';
import Footer from '../components/basic/Footer';
import ImageSynced from '../components/media/ImageSynced';
import { GlobalState } from '../containers/GlobalState';
import ModalBase from '../components/basic/ModalBase';
import BasicButton from '../components/basic/BasicButton';
import ContactElement from '../components/basic/ContactElement';
import { wsChat, wsChatClear, wsConnect, wsSend } from '../stores/mainSlice';

export default function Chat({ navigation, route }) {
    const user = useSelector((state) => state.user);
    const messages = useSelector((state) => state.server.chat);
    const contacts = useSelector((state) => state.contacts.active);
    const insets = useSafeAreaInsets();
    const dispatch = useDispatch();
    const { guid7 } = useContext(GlobalState);
    const [message, setMessage] = useState('');
    const msgList = useRef(null);

    const [showContacts, setShowContacts] = useState(false);
    const [currentContact, setCurrentContact] = useState('');

    const getContactName = (id) => {
        return contacts
            .filter((c) => c.toUser.id === id)
            .map((c) => (c.toUser.preferredName ? c.toUser.preferredName : c.toUser.mail))
            .find(() => true);
    };

    const onSend = () => {
        console.log('SEND');
        //dispatch(wsSend({ type: 'CHAT', receivers: [], data: JSON.stringify({ id: guid7(), text: message, createdAt: Date.now(), user: user.id, image: null, video: null, audio: null, system: false }) }))
        const msg = {
            fromUserId: user.id,
            toUserId: currentContact.toUser.id,
            message: `${message}`
        };
        dispatch(wsChat({ chatMsg: msg }));
        dispatch(wsSend({ msg: msg }));

        setMessage('');
    };

    const actions = [
        { icon: 'keyboard-arrow-left', text: 'footer.back', component: 'BACK' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        { icon: 'send', text: 'footer.send', exec: onSend }
    ];

    useEffect(() => {
        dispatch(wsConnect({ uuid: guid7(), reconnect: true }));
        setTimeout(() => {
            msgList.current.scrollToOffset({ offset: messages.length * 100, animated: true });
        }, 200);
    }, [messages.length]);

    const renderMessage = ({ item }) => {
        return (
            <HStack space="sm" className="w-full m-2">
                {item?.fromUserId === user.id && (
                    <Box className="border-primary-900 border rounded-full p-0.5 self-start">
                        <ImageSynced key={item?.fromUserId} uri={item?.fromUserId} isAvatar={true} size="sm" bg="white" />
                    </Box>
                )}
                <VStack className={` ${item?.fromUserId === user.id ? 'self-end' : 'self-start'} w-[80%] my-1 p-1 border-primary-900 border rounded-[16px] `}>
                    <View className="pl-[6px]">
                        <Text>{getContactName(item?.fromUserId) || 'self'}</Text>
                    </View>
                    <View>
                        <Text className="ml-[4px] text-lg text-secondary-900 line-clamp-6">
                            {item?.message}
                        </Text>
                    </View>
                </VStack>
                {item?.fromUserId !== user.id && (
                    <Box className="border-primary-900 border rounded-full p-0.5 self-start">
                        <ImageSynced key={item?.fromUserId} uri={item?.fromUserId} isAvatar={true} size="sm" bg="white" />
                    </Box>
                )}
            </HStack>
        );
    };

    return (
        <View className="flex-1 bg-secondary-50">
            <HStack space="xl" className="w-full items-center p-2">
                <BasicButton flex={1} text={'Contacts'} onPress={() => setShowContacts(!showContacts)} />
                <BasicButton flex={1} text={'Clear Messages'} onPress={() => dispatch(wsChatClear())} />
            </HStack>
            <FlatList ref={msgList} contentContainerStyle={{ paddingLeft: 8, paddingRight: 8, paddingBottom: 70 + insets.bottom }} data={messages} renderItem={renderMessage} keyExtractor={(item, index) => (item.id || 'T') + index} />
            <View className={` mb-[100px] w-full bg-secondary-50 p-2 `}>
                <FloatingLabelInput label={currentContact?.toUser?.mail ? 'Message to ' + currentContact.toUser.mail : 'pls select a contact'} value={message} isDisabled={currentContact === ''} placeholder={i18n.t('chatScreen.message')} onSubmitEditing={onSend} onChangeText={setMessage} blurOnSubmit={true} multiline={true} />
            </View>
            <Footer navigation={navigation} actions={actions} />
            <ContactsModal showModal={showContacts} setShowModal={setShowContacts} setCurrentContact={setCurrentContact} />
        </View>
    );
}

function ContactsModal({ showModal, setShowModal, setCurrentContact }) {
    const contacts = useSelector((state) => state.contacts.active);

    const renderItem = ({ item, index }) => {
        return (
            <View>
                <ContactElement
                    key={'A' + index}
                    uri={item?.contactImage?.id || item.toUser.id}
                    title={item.contactAlias || item.toUser.mail}
                    text={item.toUser.preferredName}
                    onPress={() => {
                        setCurrentContact(item);
                        setShowModal(false);
                    }}
                />
            </View>
        );
    };

    return (
        <ModalBase showModal={showModal}>
            <Text className="text-2xl text-secondary-900">{'Contacts'}</Text>
            <FlatList data={contacts} renderItem={renderItem} />
            <BasicButton onPress={() => setShowModal(false)} text={'Close'} />
        </ModalBase>
    );
}
